const languageMapping = {
  all: 0,
  'en-US': 1,
  'ja-JP': 2,
  'hi-IN': 3,
  'es-ES': 4,
  'ko-KR': 5,
};

export {languageMapping};
